import React, { FC } from "react";
import styled from "styled-components";
import GreenCheck from "../../../../../images/membership/circle-check-mark.svg";
import { Input } from "@mindmemobile/mm-shared-global";

interface Iprops {
  selector?: boolean;
  activeBgColor?: string;
  notActiveBgColor?: string;
  activeFontColor?: string;
}

export const PriceSelectorWrapper = styled.div`
  position: relative;
  .selected-price {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(8px, -8px);
    background: #fff;
  }
  .price-error-selector {
    border: 1px solid red;
  }
  img {
    height: 22px;
    width: 22px;
  }
  .price-selector-input {
    height: 30px;
    min-width: 60px;
    max-width: 75px;
    border: 1px solid #aaa;
    border-radius: 6px;
    padding: 0px 5px;

    &:focus {
      outline: none;
    }
  }
  .custom-dollar-icon {
    &::before {
      content: "$";
      position: absolute;
      top: 49%;
      left: 9px;
      transform: translateY(-50%);
      font-size: 18px;
      color: #555;
    }
  }
`;
export const PriceSelector = styled.div<Iprops>`
  width: 120px;
  height: 50px;
  border: 1px solid #aaa;
  background-color: ${(props) =>
    props.selector ? props.notActiveBgColor : "#f8f8f8"};
  border-radius: 8px;
  font-size: 18px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.color || "#555"};
  &.isActive {
    background-color: ${(props) => props.activeBgColor || "#2c3e50"};
    color: ${(props) => props.activeFontColor || "#fff"};
  }
`;
type IProps = {
  value?: string | any;
  isSelected?: boolean;
  selector?: boolean;
  className?: string;
  onClick?: () => void;
  onChange?: (value: string) => void;
  selectedBgColor?: string;
  notSelectedBgColor?: string;
  showInput?: boolean;
  showError?: boolean;
  color?: string;
  activeFontColor?: string;
};

const PricingOption: FC<IProps> = ({
  value,
  onClick,
  onChange,
  isSelected = false,
  selector = false,
  className,
  selectedBgColor,
  notSelectedBgColor,
  showInput,
  showError = false,
  color,
  activeFontColor,
}) => {
  return (
    <PriceSelectorWrapper onClick={() => onClick && onClick()}>
      <PriceSelector
        selector={selector}
        className={`${className} ${value && !showInput ? "" : "custom-dollar-icon"} ${showError ? "price-error-selector" : ""}`}
        activeBgColor={selectedBgColor || "#2c3e50"}
        notActiveBgColor={notSelectedBgColor || "#f8f8f8"}
        color={color}
        activeFontColor={activeFontColor || "#fff"}
      >
        {!showInput ? (
          <>{value ? `$${value}` : ""}</>
        ) : (
          // <FlexContainer fxLayout="row" className="dollar-input" justifyContent="center">
          <div>
            <Input
              type="text"
              value={value}
              onChange={(e) => onChange && onChange(e.target.value)}
              className="price-selector-input"
              stopClickEvent={true}
            />
          </div>
          // </FlexContainer>
        )}
      </PriceSelector>
      {isSelected && (
        <div className="selected-price">
          <img src={GreenCheck} />
        </div>
      )}
    </PriceSelectorWrapper>
  );
};

export default PricingOption;
